import React, { Component } from 'react';

class CheckHomeBanking extends Component {
    constructor(props) {
        super(props);
        this.changeCheck = this.changeCheck.bind(this);
    }

    changeCheck(event) {
        this.props.changeCheck("checkHomeBanking", event.target.checked)
    }

    render () {
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <ul className="no-bullets no-padding no-margin">
                        <li className="inlineListItem2 lg-margin">
                           <div className="default-checkbox">
                                <input id="checkHomeBanking" type="checkbox" checked={this.props.data.CheckHomeBanking} onChange={this.changeCheck}  />
                                <label className="label-primary" htmlFor="checkHomeBanking"></label>
                            </div>
                        </li>
                        <li className="inlineListItem2">
                            <label className="label-primary" htmlFor="checkHomeBanking">Debe cambiar la clave del home banking de Visa en el próximo acceso</label>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
};

export default CheckHomeBanking;